module.exports = __webpack_public_path__ + "img/icon41.7348781b.png";